import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ModalModule } from "ngx-bootstrap/modal";
import { PopoverModule } from "ngx-bootstrap/popover";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MomentModule } from "ngx-moment";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "./shared/shared.module";
import { BaseChartDirective } from "ng2-charts";

import * as toastr from "toastr";

toastr.options.escapeHtml = true;
toastr.options.closeButton = false;
toastr.options.debug = false;
toastr.options.newestOnTop = true;
toastr.options.progressBar = true;
toastr.options.positionClass = "toast-top-right";
toastr.options.preventDuplicates = false;
toastr.options.onclick = null;
toastr.options.showDuration = 300;
toastr.options.hideDuration = 1000;
toastr.options.timeOut = 3000;
toastr.options.extendedTimeOut = 3000;
toastr.options.showEasing = "swing";
toastr.options.hideEasing = "linear";
toastr.options.showMethod = "fadeIn";
toastr.options.hideMethod = "fadeOut";

import { AppComponent } from "./app.component";
import { HomeModule } from "./home/home.module";
import { UserModule } from "./user/user.module";
import { AssociationModule } from "./association/association.module";
import { AdministrationModule } from "./administration/administration.module";
import { AnalyticsModule } from "./analytics/analytics.module";
import { DeviceModule } from "./device/device.module";
import { AccountModule } from "./account/account.module";
import { AnnotationModule } from "./annotation/annotation.module";
import { DownloadModule } from "./download/download.module";
import { AppRouting } from "./app.routing";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";

import {
  SignalRService,
  SignalREventService,
  EventSubscriptionService,
  ToastrService,
  GlobalService,
  AuthorizationService,
  SectionService,
  UserService,
  FMIProductService,
  LanguageService,
  AssociationService,
  PresetService,
  MinesiteService,
  EquipmentService,
  ModelService,
  PoweredByService,
  ClassificationService,
  DocumentService,
  DeviceService,
  AttributeService,
  AccountService,
  AnnotationService,
  DeleteConfirmationComponent,
  CapitalizePipe,
  CanActivateGuard,
  ProjectService,
  CompanyService,
  PartsManualService,
  SurveyService,
  AnalyticsService,
  StringFormatterService,
  ExportService,
  LoggingService,
} from "./shared/index";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@NgModule({
  declarations: [AppComponent, DeleteConfirmationComponent, CapitalizePipe],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BaseChartDirective,
    MomentModule,
    AppRouting,
    HomeModule,
    UserModule,
    AssociationModule,
    DeviceModule,
    AdministrationModule,
    AnalyticsModule,
    AccountModule,
    AnnotationModule,
    DownloadModule,
    SharedModule,
    FormsModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    DragDropModule,
    BrowserAnimationsModule,
  ],
  providers: [
    SignalRService,
    SignalREventService,
    EventSubscriptionService,
    ToastrService,
    GlobalService,
    AuthorizationService,
    HttpClient,
    AssociationService,
    UserService,
    FMIProductService,
    DocumentService,
    SectionService,
    LanguageService,
    MinesiteService,
    EquipmentService,
    PresetService,
    ModelService,
    PoweredByService,
    ClassificationService,
    DeviceService,
    AttributeService,
    AccountService,
    AnnotationService,
    ProjectService,
    CanActivateGuard,
    CompanyService,
    PartsManualService,
    SurveyService,
    AnalyticsService,
    StringFormatterService,
    ExportService,
    LoggingService,
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    //PdfViewerModule
  ],
})
export class AppModule {}
